import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box } from '@mui/material';
import { title } from 'process';
import { on } from 'events';
import {Link as RouterLink} from 'react-router-dom';


interface MyComponentProps {
  data: { name: string; path: string, fromMultiAgentVBuilder?: Boolean}[]
}


const Breadcrumb: React.FC<MyComponentProps> = (props) => {
  const breadcrumbsFirst = [<Link underline="hover" key="1" color="inherit" href="/home">Home</Link>,]
  var title = ""
  const breadcrumbs = props.data.map((item, index) => {
    if (index === props.data.length - 1) {
      title = item.name
      return (
        <Typography key="3" sx={{ color: 'text.primary' }}>
          {title}
        </Typography>)
    } else {
      return (
        <Link underline="hover" key="1" color="inherit" to={item.path} component={RouterLink}
          state={{fromMultiAgentVBuilder: item?.fromMultiAgentVBuilder ? true : false }}>
          {item.name}
        </Link>
      )
    }
  })
  // const breadcrumbs = [
  //   <Link underline="hover" key="1" color="inherit" href="/">
  //     Home
  //   </Link>,
  //   <Typography key="3" sx={{ color: 'text.primary' }}>
  //     Profile
  //   </Typography>,
  // ];
  return (
    <Box
      sx={{
        mb: 3,
        display: {xs: "none", sm: "block"},
      }}
    >
      <Breadcrumbs
        separator={<NavigateNextIcon sx={{fontSize:"17px"}}/>}
        aria-label="breadcrumb"
      >
        {[...breadcrumbsFirst, ...breadcrumbs]}
      </Breadcrumbs>
      <Typography variant="h6">{title}</Typography>
    </Box>
  )
}

export default Breadcrumb